import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {firestore} from "../../config/firebaseConfig";

export const fetchInternalIdManyFound = createAsyncThunk(
    'SyncErrors/FInternalIdManyFound',
    async ({onResolve}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const docSnap = await firestore.collection('syncError')
                    .doc('InternalIdManyFound').get();
                onResolve && onResolve()
                resolve(docSnap.data())
            } catch (e) {
                // console.log(e)
                onResolve && onResolve()
                reject(e)
            }

        })
    }
)
export const fetchInternalIdNotFound = createAsyncThunk(
    'SyncErrors/InternalIdNotFound',
    async ({onResolve}) => {
        return new Promise(async (resolve, reject) => {
            try {
                const docSnap = await firestore.collection('syncError')
                    .doc('InternalIdNotFound').get();
                onResolve && onResolve()
                resolve(docSnap.data())
            } catch (e) {
                // console.log(e)
                onResolve && onResolve()
                reject(e)
            }

        })
    }
)



const syncErrorsSlice = createSlice({
    name: 'SyncErrors',
    initialState: {
        list: null,
        previousAction: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchInternalIdManyFound.fulfilled, (state, action) => {
            state.list = action.payload?.data;
            state.previousAction = action.type;
        })

        builder.addCase(fetchInternalIdNotFound.fulfilled, (state, action) => {
            state.list = action.payload?.data;
            state.previousAction = action.type;
        })

    }
})

export const selectSyncErrors = state => state.syncErrors;

export default syncErrorsSlice.reducer;
